/**
 * Utilitário de Gerenciamento de Token
 * Fornece uma forma para módulos não-React (como httpClient) acessarem o token
 * Usa um padrão singleton para manter uma referência ao token atual
 */

let currentToken: string | null = null;

/**
 * Atualiza o token atual
 * Deve ser chamado pelo AuthProvider sempre que o token mudar
 */
export const setCurrentToken = (token: string | null): void => {
  currentToken = token;
};

/**
 * Obtém o token atual
 * Usado por httpClient e outros módulos não-React
 */
export const getCurrentToken = (): string | null => {
  return currentToken;
};
